import ApiClient from "../helpers/ApiClient";
import useSWR from "swr";

const fetcher = (url) => ApiClient.get(url).then((res) => res.data);

export function useInvoices({ type, from = null, to = null } = {}) {
  const APIURL = `/invoices?type=${type}&from=${from}&to=${to}`;
  const { data, error, isLoading, mutate } = useSWR(APIURL, fetcher, { keepPreviousData: true });
  return {
    data,
    error,
    isLoading,
    mutate,
    APIURL,
  };
}

export async function getInvoicesInit() {
  try {
    const res = await ApiClient.get("/invoices/init");
    return res;
  } catch (error) {
    throw error;
  }
}

export async function getInvoiceOrders(invoiceId, orderIds) {
  try {
    const res = await ApiClient.post("/invoices/orders", {
      invoiceId,
      orderIds
    });
    return res;
  } catch (error) {
    throw error;
  }
}

export async function searchInvoices(query) {
  try {
    const response = await ApiClient.get(`/invoices/search?q=${encodeURIComponent(query)}`);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function collectDue({ invoice_id, amount, payment_date, payment_method, notes, multi_payments }) {
  try {
    const res = await ApiClient.post("/invoices/collect-due", {
      invoice_id,
      amount,
      payment_date,
      payment_method,
      notes,
      multi_payments
    });
    return res;
  } catch (error) {
    throw error;
  }
}

export function useCustomerDues(search = "", from = null, to = null) {
  const APIURL = `/invoices/customer-dues?search=${encodeURIComponent(search)}&from=${from}&to=${to}`;
  const { data, error, isLoading, mutate } = useSWR(APIURL, fetcher, { keepPreviousData: true });
  return {
    data,
    error,
    isLoading,
    mutate,
    APIURL,
  };
}

export function useCustomerStatement(customerId, from = "", to = "") {
  const query = [];
  if (from) query.push(`from=${from}`);
  if (to) query.push(`to=${to}`);
  const qStr = query.length > 0 ? `?${query.join("&")}` : "";
  const APIURL = customerId ? `/invoices/customer-statement/${encodeURIComponent(customerId)}${qStr}` : null;
  const { data, error, isLoading, mutate } = useSWR(APIURL, fetcher);
  return {
    data,
    error,
    isLoading,
    mutate,
    APIURL,
  };
}

export async function collectCustomerDue({ customer_id, amount, payment_method, notes, multi_payments, payment_date }) {
  try {
    const res = await ApiClient.post("/invoices/collect-customer-due", {
      customer_id,
      amount,
      payment_method,
      notes,
      multi_payments,
      payment_date
    });
    return res;
  } catch (error) {
    throw error;
  }
}

export async function voidInvoice(invoiceId, reason) {
  try {
    const res = await ApiClient.post("/invoices/void", { invoiceId, reason });
    return res;
  } catch (error) {
    throw error;
  }
}

export async function addManualCustomerDue({ customer_id, amount, date, notes }) {
  try {
    const res = await ApiClient.post("/invoices/manual-due", { customer_id, amount, date, notes });
    return res;
  } catch (error) {
    throw error;
  }
}
